const theme = {
  '--gray-color': '#E6E6E6',
  '--orange-color': '#EB5A3B',
  '--orange-hover-color': '#d94d23',
  '--orange-datepicker-selection-color': 'rgba(235, 90, 59, 0.6)',
  '--blue-color': '#232F44',
  '--white-color': '#FFFFFF',
  '--black-color': '#000000',
  '--navtext-color': '#FFFFFF',
  '--header-color': '#232F44',
};

export default theme;